import { Component, OnInit } from '@angular/core';
import { FOOTER } from '../../../core/constants/footer';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class FooterComponent implements OnInit {
  footer = FOOTER;

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  navigateTo(url: string) {
    if (url) {
      if (url.includes('https')) {
        window.open(url, '_blank');
      }else{
        this.router.navigateByUrl(url);
      }
    }
  }

}
